/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Navigation/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Navigation({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/Navigation"
  
}) {
  return null
}